export default {

    /**
     * Resolve a Short URL to a relative URL.
     * @param id
     * @returns {*}
     */
    getUrl: function(id) {
        return $.ajax({
            url: context.path + "/webservices/rest/shorturl/" + id,
            contentType: "application/json",
            method: "GET"
        });
    }
};